import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { IpAddressTable, IpAddressEntry } from "../InfoSets/IpAddressTable";
import { VendorNames } from "../InfoSets/ProductInfo";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface VirtualMachineInfoJsonWrapper {
//    vm_info: VirtualMachineInfoJson;
//}

//export interface VirtualMachineInfoJson {
//    vm_id: string;
//    uuid: string;
//    name: string;
//    config_file: string;
//    state: string;
//    guest_os: string;
//    guest_state: string;
//    ip_address: string;
//    ip_info: InfoSetEntriesJson<IpAddressEntryJsonWrapper>;
//    mac_address: string;
//    virtual_network: string;
//    host_id: string;
//    memory_limit: string;
//    memory_reservation: string;
//    cpu_load_percentage: string;
//    virtual_vendor: string;
//}

export class VirtualMachineInfo extends InfoSet
{
    //public static FromJson(json: VirtualMachineInfoJson, device: Device): VirtualMachineInfo {
    //    var result = new VirtualMachineInfo(device, json.vm_id);

    //    if (json.uuid !== undefined)
    //        result.UUID = json.uuid;
    //    if (json.name !== undefined)
    //        result.Name = json.name;
    //    if (json.config_file !== undefined)
    //        result.ConfigFile = json.config_file;
    //    if (json.state !== undefined)
    //        result.State = json.state;
    //    if (json.guest_os !== undefined)
    //        result.GuestOS = json.guest_os;
    //    if (json.guest_state !== undefined)
    //        result.GuestState = json.guest_state;
    //    if (json.ip_address !== undefined)
    //        result.IpAddress = IpAddress.Create(json.ip_address);
    //    if (json.ip_info !== undefined)
    //        result.IpAddressConfig = IpAddressTable.FromJson(json.ip_info, null);
    //    if (json.mac_address !== undefined)
    //        result.MacAddress = MacAddress.CreateFromString(json.mac_address);
    //    if (json.virtual_network !== undefined)
    //        result.VirtualNetwork = json.virtual_network;
    //    if (json.host_id !== undefined)
    //        result.HostID = json.host_id;
    //    if (json.memory_limit !== undefined)
    //        result.MemoryLimit = parseInt(json.memory_limit);
    //    if (json.memory_reservation !== undefined)
    //        result.MemoryReservation = parseInt(json.memory_reservation);
    //    if (json.cpu_load_percentage !== undefined)
    //        result.CpuLoadPercentage = parseInt(json.cpu_load_percentage);
    //    if (json.virtual_vendor !== undefined)
    //        result.VirtualVendor = json.virtual_vendor;

    //    return result;
    //}

	// NOTE: When this object is stoared as PART of a VirtualMachineTable; VmID is the KEY.  Use the SET CAREFULLY!
	public VmID:string;

	public UUID:string;
	public get HasUUID(): boolean {
		return !!this.UUID;
	}

	public Name:string;
	public get HasName(): boolean {
		return !!this.Name;
	}

	public ConfigFile:string;
	public get HasConfigFile(): boolean {
		return !!this.ConfigFile;
	}

	public State:string;
	public get HasState(): boolean {
		return !!this.State;
	}

	public GuestOS:string;
	public get HasGuestOS(): boolean {
		return !!this.GuestOS;
	}

	public GuestState:string;
	public get HasGuestState(): boolean {
		return !!this.GuestState;
	}

	// PRIMARY
	public IpAddress: IpAddress;
	public get HasIpAddress(): boolean {
		return this.IpAddress && this.IpAddress.IsValidDiscoveryAddress;
	}

	public MacAddress: MacAddress;
	public get HasMacAddress(): boolean {
		return this.MacAddress && !this.MacAddress.IsNull;
	}

	public IpAddressConfig: IpAddressTable;

	public VirtualNetwork:string;
	public get HasVirtualNetwork(): boolean {
		return !!this.VirtualNetwork;
    }

    public HostID: string;
    public get HasHostID(): boolean {
        return !!this.HostID;
    }

	public MemoryReservation:number;
	public get HasMemoryReservation(): boolean {
		return this.MemoryReservation >= 0;
	}

	public MemoryLimit:number;
	public get HasMemoryLimit(): boolean {
		return this.MemoryLimit >= 0;
	}

	public CpuLoadPercentage:number;
	public get HasCpuLoadPercentage(): boolean {
		return this.CpuLoadPercentage >= 0;
	}

	public VirtualVendor:string;
	public get HasVirtualVendor(): boolean {
		return !!this.VirtualVendor;
	}

	public get IsVMware(): boolean {
		return this.HasVirtualVendor && this.VirtualVendor == VendorNames.VMware;
	}

	public get IsHyperV(): boolean {
		return this.HasVirtualVendor && this.VirtualVendor == VendorNames.Microsoft;
	}

	constructor(device?:Device, vmID:string = ''){
		super(device)
		this.VmID = vmID;

		this.Init();
	}

	private Init():void {
		this.UUID = '';
		this.Name = '';
		this.ConfigFile = '';
		this.State = '';

		this.GuestOS = '';
		this.GuestState = '';

		// PRIMARY
		this.IpAddress = null;
		this.MacAddress = null;

		// SECONDARY
		if (this.IpAddressConfig == null)
			this.IpAddressConfig = new IpAddressTable(null);
		else
			this.IpAddressConfig.Clear();

		this.VirtualNetwork = '';
        this.HostID = '';
		this.MemoryReservation = -1;
		this.MemoryLimit = -1;
		this.CpuLoadPercentage = -1;

		this.VirtualVendor = '';
	}

	public Copy(other: VirtualMachineInfo) {
		this.Init();

		this.VmID = other.VmID + '';

		if (other.HasUUID)
			this.UUID = other.UUID + '';
		if (other.HasName)
			this.Name = other.Name + '';
		if (other.HasConfigFile)
			this.ConfigFile = other.ConfigFile + '';
		if (other.HasState)
			this.State = other.State + '';
		if (other.HasGuestOS)
			this.GuestOS = other.GuestOS + '';
		if (other.HasGuestState)
			this.GuestState = other.GuestState + '';
		if (other.HasIpAddress)
			this.IpAddress = other.IpAddress.Clone();
		if (other.HasMacAddress)
			this.MacAddress = other.MacAddress.Clone();

		if (other.IpAddressConfig != null)
			this.IpAddressConfig = other.IpAddressConfig.Clone();

		if (other.HasVirtualNetwork)
			this.VirtualNetwork = other.VirtualNetwork + '';

        if (other.HasHostID)
            this.HostID = other.HostID + '';

		if (other.HasMemoryReservation)
			this.MemoryReservation = other.MemoryReservation;

		if (other.HasMemoryLimit)
			this.MemoryLimit = other.MemoryLimit;

		if (other.HasCpuLoadPercentage)
			this.CpuLoadPercentage = other.CpuLoadPercentage;

		if (other.HasVirtualVendor)
			this.VirtualVendor = other.VirtualVendor + '';
	}

	public Write(obj: any, context: any): void {
		obj.vm_info = {};
		obj = obj.vm_info;

		obj.vm_id = this.VmID;

		if (this.HasUUID)
			obj.uuid = this.UUID;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasConfigFile)
			obj.config_file = this.ConfigFile;

		if (this.HasState)
			obj.state = this.State;

		if (this.HasGuestOS)
			obj.guest_os = this.GuestOS;

		if (this.HasGuestState)
			obj.guest_state = this.GuestState;

		if (this.HasIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);

		if ((this.IpAddressConfig != null) && (this.IpAddressConfig.Count > 0))
			this.IpAddressConfig.Write(obj, context);

		if (this.HasVirtualNetwork)
			obj.virtual_network = this.VirtualNetwork;

		if (this.HasMemoryLimit)
			obj.memory_limit = ValueEncoder.EncodeInteger(this.MemoryLimit);

		if (this.HasMemoryReservation)
			obj.memory_reservation = ValueEncoder.EncodeInteger(this.MemoryReservation);

		if (this.HasCpuLoadPercentage)
			obj.cpu_load_percentage = ValueEncoder.EncodeInteger(this.CpuLoadPercentage);

		if (this.HasVirtualVendor)
			obj.virtual_vendor = this.VirtualVendor;
	}

	public Read(obj: any, context: any): void {
		if (!obj.vm_info)
			throw new Error();
		obj = obj.vm_info;

		if (obj.vm_id !== undefined)
			this.VmID = obj.vm_id;

		if (obj.uuid !== undefined)
			this.UUID = obj.uuid;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.config_file !== undefined)
			this.ConfigFile = obj.config_file;

		if (obj.state !== undefined)
			this.State = obj.state;

		if (obj.guest_os !== undefined)
			this.GuestOS = obj.guest_os;

		if (obj.guest_state !== undefined)
			this.GuestState = obj.guest_state;

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

		if (obj.ip_info !== undefined)
			this.IpAddressConfig.Read(obj, context);

		if (obj.virtual_network !== undefined)
			this.VirtualNetwork = obj.virtual_network;

		if (obj.memory_limit !== undefined)
			this.MemoryLimit = ValueEncoder.DecodeInteger(obj.memory_limit);

		if (obj.memory_reservation !== undefined)
			this.MemoryReservation = ValueEncoder.DecodeInteger(obj.memory_reservation);

		if (obj.cpu_load_percentage !== undefined)
			this.CpuLoadPercentage = ValueEncoder.DecodeInteger(obj.cpu_load_percentage);

		if (obj.virtual_vendor !== undefined)
			this.VirtualVendor = obj.virtual_vendor;
	}
}
